/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import { Checkbox } from '@mui/material';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { UPDATE_LISTINGS_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import { updateListing } from 'modules/authorizations/store/actions/homesale.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';
import { getHomesaleInfo } from 'modules/authorizations/authorizations.actions';

const ORIGINAL_LISTING_TYPE_TITLE = 'Origlist';

const BrokerInfoCard = props => {
  const [isLoading, setIsLoading] = useState(false);

  const { listingInfo, isReadOnly, id, selectedByListingTypesEnum, listingTypesEnum } = props;

  const tabs = [{ header: 'Listing Info', order: 1, iconPath: ['fas', 'house'] }];

  const statusOptions = [
    { title: 'Active', id: '5462aeca-0424-4578-a841-0cfbc871366e' },
    { title: 'Inactive', id: '1dc113a4-6986-4d4b-8d9f-84622b8c0e63' }
  ];

  const selectedByOptions =
    selectedByListingTypesEnum && selectedByListingTypesEnum.length > 0
      ? selectedByListingTypesEnum.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const listingTypes =
    listingTypesEnum && listingTypesEnum.length > 0
      ? listingTypesEnum.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const originalListingType = listingTypes.find(type => type.title === ORIGINAL_LISTING_TYPE_TITLE) || null;

  // Only the very first listing on a homesale is the original listing, so the type can never be picked or changed here.
  const isOriginalListing = !!originalListingType && listingInfo?.listingTypeId === originalListingType.id;

  const filteredListingTypes = () => {
    let filtered = [];
    if (listingTypes && listingTypes.length > 0) {
      if (originalListingType) {
        filtered.push({ ...originalListingType, disabled: true });
      }
      listingTypes.map(type => {
        if (type.title !== ORIGINAL_LISTING_TYPE_TITLE && type.id !== '00000000-0000-0000-0000-000000000000') {
          filtered.push(type);
        }
      });
    }
    return filtered;
  };

  const dateDiff = (endDate, startDate) => {
    const diffInMs = endDate - startDate;
    return Math.round(diffInMs / (1000 * 60 * 60 * 24));
  };

  const summaries = [
    {
      header: 'Status',
      accessorKey: 'listingStatusId',
      type: 'dropdown-v2',
      required: false,
      options: statusOptions,
      value: listingInfo ? listingInfo.listingStatusId : '',
      tab: 1
    },
    {
      header: 'Selected By',
      accessorKey: 'selectedByListingTypeId',
      type: 'dropdown-v2',
      required: false,
      options: selectedByOptions,
      value: listingInfo ? listingInfo.selectedByListingTypeId : '',
      tab: 1
    },
    {
      header: 'Type',
      accessorKey: 'listingTypeId',
      type: 'dropdown-v2',
      required: false,
      disabled: isOriginalListing,
      options: filteredListingTypes(),
      value: listingInfo ? listingInfo.listingTypeId : '',
      tab: 1
    },
    // { header: 'List Date', accessorKey: 'listDate', type: 'date', required: false, value: listingInfo ? listingInfo.listDate : '', tab: 1 },
    {
      header: 'Listing Signed',
      accessorKey: 'listDate',
      type: 'date',
      required: false,
      value: listingInfo ? listingInfo.listDate : '',
      tab: 1
    },
    {
      header: 'List Begins',
      accessorKey: 'listBegins',
      type: 'date',
      required: false,
      value: listingInfo ? listingInfo.listBegins : '',
      tab: 1
    },
    {
      header: 'List Ends',
      accessorKey: 'listEnds',
      type: 'date',
      required: false,
      value: listingInfo ? listingInfo.listEnds : '',
      tab: 1
    },
    // { header: 'List Agreement', accessorKey: 'listAgreementDate', type: 'date', required: false, value: listingInfo ? listingInfo.listAgreementDate : '', tab: 1 },
    {
      header: 'List Price',
      accessorKey: 'listPrice',
      type: 'money',
      required: false,
      value: listingInfo ? listingInfo.listPrice : '',
      tab: 1
    },
    {
      header: 'Days on Market',
      accessorKey: 'daysOnMarketAuto',
      type: 'text',
      required: false,
      value: listingInfo && listingInfo.listBegins ? dateDiff(new Date(), new Date(listingInfo.listBegins)) : '',
      hideInModal: true,
      tab: 1
    },
    {
      header: 'Exclusion Clause',
      accessorKey: 'hasExclusionClause',
      type: 'checkbox',
      required: false,
      value: listingInfo ? listingInfo.hasExclusionClause : '',
      tab: 1,
      Cell: ({ cell }) => (
        <Checkbox name="hasExclusionClause" label="Active" checked={cell.row.original.hasExclusionClause} disabled={true} />
      )
    },
    { dividerLine: true, tab: 1 },
    {
      header: 'Incentives',
      accessorKey: 'incentives',
      type: 'notes',
      required: false,
      value: listingInfo ? listingInfo.incentives : '',
      showBelow: true,
      tab: 1
    }
  ];

  const updateFields = async (tab, values) => {
    setIsLoading(true);

    let newValues = { ...listingInfo };

    newValues.listingStatusId = values.listingStatusId;
    newValues.selectedByListingTypeId = values.selectedByListingTypeId;
    newValues.listingTypeId = values.listingTypeId;
    newValues.listDate = values.listDate === '' ? null : values.listDate;
    newValues.listBegins = values.listBegins === '' ? null : values.listBegins;
    newValues.listEnds = values.listEnds === '' ? null : values.listEnds;
    newValues.listPrice = values.listPrice;
    newValues.hasExclusionClause = values.hasExclusionClause;
    newValues.incentives = values.incentives;

    const resp = await props.updateListing(newValues, id);
    if (resp.type === UPDATE_LISTINGS_FAILURE) {
      props.showToast('Failed to update broker info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      await props.getHomesaleInfo(id);
      setIsLoading(false);
      return true;
    }
  };

  return (
    <EditableCard
      tabs={tabs}
      summaries={summaries}
      numColumns={5}
      updateFields={updateFields}
      isLoading={isLoading}
      hideEdit={isReadOnly}
    />
  );
};

const mapStateToProps = state => {
  const { selectedByListingTypes, listingTypes } = state.enumerations.allEnums;
  return {
    selectedByListingTypesEnum: selectedByListingTypes,
    listingTypesEnum: listingTypes
  };
};

export default compose(
  connect(mapStateToProps, {
    updateListing,
    showToast,
    getHomesaleInfo
  })
)(BrokerInfoCard);
